import { createContext, useContext } from 'react';

import type { TableContextProps } from './table.types';

const TableContext = createContext<null | TableContextProps>(null);

export function useTableContext(): null | TableContextProps {
  return useContext(TableContext);
}

export default TableContext;
